/* eslint-disable jsx-a11y/media-has-caption */
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { withUAPLThemedStyles } from '../../with-themed-styles';

import { getAppAdsBasePlacementStyles } from '../../styles/ad-placement-components/app-ads-ad-placement-styles';
import { AppAdsBasePlacement } from './app-ads-base-placement';
import type { UAPPlacementComponentProps, UAPVideo } from '../../@types';


export const AppAdsVideoHorizontalPlacementInner = ({
  classes,
  videos,
}: UAPPlacementComponentProps) => {
  const {
    src,
  }: UAPVideo = videos && videos.length > 0 ? videos[0] : {};

  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load();
    }
  }, [src]);

  return (
    <AppAdsBasePlacement
      classes={classes}
    >
      <div className={classes.videoPlayerRoot}>
        <video
          controls
          disablePictureInPicture
          controlsList="nodownload nofullscreen noremoteplayback noplaybackrate"
          style={{ height: '100%', width: '100%', borderRadius: '10px' }}
          ref={videoRef}
        >
          <source src={src} />
          <track
            kind="captions"
            src=""
            srcLang="en"
            label="English"
            default
          />
        </video>
      </div>
    </AppAdsBasePlacement>
  );
};

AppAdsVideoHorizontalPlacementInner.propTypes = {
  classes: PropTypes.shape({
    videoPlayerRoot: PropTypes.string,
  }),
  videos: PropTypes.arrayOf(PropTypes.shape({
    src: PropTypes.string,
  })),
};

AppAdsVideoHorizontalPlacementInner.defaultProps = {
  classes: {},
  videos: null,
};

export const AppAdsVideoHorizontalPlacement = withUAPLThemedStyles(

  (props: UAPPlacementComponentProps) => <AppAdsVideoHorizontalPlacementInner {...props} />,
  getAppAdsBasePlacementStyles,
  { componentName: 'AppAdsVideo16x9Placement' }
);
